import { subMonths } from 'date-fns'
import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import {
  dataForCurrencyIsAccepted,
  dataForCurrencyIsRejected,
} from '../../actions/currency/requestForCurrency'
import { callFetch } from '../../actions/fetch'
import { localStorage } from '../../database'
import fetchCurrency from '../../models/Currency/fetchCurrency'
import { getCurrency } from '../../reducers/currency/selectors/currency'
import { UserProfileActions as ObjectActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadCurrency() {
  const { UserDriver: Driver, Names } = localStorage
  const { CurrencyStorage } = Names

  const lastCurrencySync = Driver.getItem(CurrencyStorage.LastSync, null)
  if (lastCurrencySync) {
    const lastSyncToDate = new Date(+lastCurrencySync)
    const threshold = subMonths(new Date(), 1)
    if (lastSyncToDate >= threshold) {
      const currenciesString = Driver.getItem(CurrencyStorage.Currencies, null)
      if (currenciesString) {
        yield put(dataForCurrencyIsAccepted(JSON.parse(currenciesString)))
        return
      }
    }
  }

  try {
    const actionNames = fetchActionsName(ActionNames.LoadCurrencies)
    const [{ service }, oldCurrency] = yield all([
      take(actionNames.output),
      select(getCurrency),
      put(callFetch(actionNames.input, actionNames.output, fetchCurrency)),
    ])

    if (oldCurrency !== undefined) {
      return yield put(dataForCurrencyIsAccepted(oldCurrency))
    }

    const currency = yield call(service)
    Driver.setItem(CurrencyStorage.LastSync, (+new Date()).toString())
    Driver.setItem(CurrencyStorage.Currencies, JSON.stringify(currency))
    yield put(dataForCurrencyIsAccepted(currency))
  } catch (e) {
    yield put(dataForCurrencyIsRejected(e.message))
  }
}

export default function*() {
  yield takeLatest(ObjectActions.RequestDataForUserProfile, loadCurrency)
}
